import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  SourcesOfIncomeFormType,
  FormErrors,
  getSchema,
} from '../../forms/sourcesOfIncomeForm';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent, type FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: SourcesOfIncomeFormType;
  onSubmit: (values: SourcesOfIncomeFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
  subTitle?: string;
  submitDisabled?: boolean;
}

export const SourcesOfIncome = ({
  initialValues,
  canGoBack,
  submitLoading,
  formError,
  onGoBack,
  onSubmit,
  clientType,
  subTitle,
  files,
  onAddFiles,
  onRemoveFile,
  submitDisabled,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t);
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.sourcesOfIncome.subtitle')}
      title={t('onboarding.sourcesOfIncome.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <FormContent
          files={files}
          onAddFiles={onAddFiles}
          onRemoveFile={onRemoveFile}
        />
      </Stack>
    </FormBodyWrapper>
  );
};
